import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Alert, IAlert } from '../../core/models/i-alert';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  subject = new Subject<IAlert | void>();
  constructor() {}
  getAlert(): Observable<IAlert | void> {
    return this.subject.asObservable();
  }

  success(message: string) {
    this.subject.next(new Alert(message, 'success'));
  }

  info(message: string) {
    this.subject.next(new Alert(message, 'info'));
  }

  warning(message: string) {
    this.subject.next(new Alert(message, 'warning'));
  }

  error(message: string) {
    this.subject.next(new Alert(message, 'error'));
  }

  clear() {
    this.subject.next();
  }
}
